const OFFICE_HANDOFF_KEY = 'masterAdmin_officeHandoff';

export function beginOfficeHandoff() {
  sessionStorage.setItem(OFFICE_HANDOFF_KEY, '1');
}

export function endOfficeHandoff() {
  sessionStorage.removeItem(OFFICE_HANDOFF_KEY);
}

export function isOfficeHandoff(): boolean {
  try {
    return sessionStorage.getItem(OFFICE_HANDOFF_KEY) === '1';
  } catch {
    return false;
  }
}
